// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1f9b6684","498":"71d2491c","513":"66408d13","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};